
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/rEditor/rootComps/helpHome/blocks/block.scss.css.virtualfile';
        module.exports = {"block":"_block_l1grl_7","blockTitle":"_blockTitle_l1grl_15","blockTitleLabel":"_blockTitleLabel_l1grl_19"};